module.exports = __webpack_public_path__ + "img/Bild 13 Pneumatische Tragstruktur Corpform.72ae20e0.jpg";